module.exports = __webpack_public_path__ + "static/media/undraw_product_photography_91i2.58f408ea.png";